import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { createGamixterTheme } from "./AdminTheme";

// Stub for backward compatibility — dark mode removed
export const useThemeMode = () => ({ mode: "light" as const, toggleMode: () => {} });

const theme = createGamixterTheme();

export function GamixterThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <MuiThemeProvider theme={theme}>
      {children}
    </MuiThemeProvider>
  );
}
